import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProofBar } from './components/ProofBar';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full flex flex-col" data-id="element-0" data-mp="23vkzqt1dsvr1">
      <UrgencyBar data-id="element-1" data-mp="23v2tr4ox335x" />
      <HeroSection data-id="element-2" data-mp="23ti67z10skhk" />
      <ProofBar data-id="element-3" data-mp="3ik7jmqgv0tve" />
      <PainSection data-id="element-4" data-mp="3ikqwvtvkeu33" />
      <MechanismSection data-id="element-5" data-mp="3ijfwm41bw4gq" />
      <ProductSection data-id="element-6" data-mp="3ihv1ac76whht" />
      <BenefitsSection data-id="element-7" data-mp="3mlavl1vse5rc" />
      <ForWhomSection data-id="element-8" data-mp="3mkrgdsxitvh0" />
      <OfferSection data-id="element-9" data-mp="3mjzrt22ccy08" />
      <FaqSection data-id="element-10" data-mp="3mjg93j4va5l5" />
      <FinalCta data-id="element-11" data-mp="3rc9co3oln7vn" />
      <Footer data-id="element-12" data-mp="3rbrbqtqzs5he" />
      <RecentPurchaseToast data-id="element-13" data-mp="3rdaq2et386gj" />
    </div>;
}